import { render, staticRenderFns } from "./AddPropertyToCategory.vue?vue&type=template&id=5bbc0e1b&"
import script from "./AddPropertyToCategory.vue?vue&type=script&lang=js&"
export * from "./AddPropertyToCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports